import { assetPaths } from '../components/data/assetPaths';

export default class PreloadScene extends Phaser.Scene {
    private loadingText: Phaser.GameObjects.Text;

    constructor() {
        super({ key: 'PreloadScene' });
    }

    preload() {}

    create(): void {
        this.initLoadingText();
        this.loadAssets();
    }

    private initLoadingText(): void {
        const { width, height } = this.scale.gameSize;
        this.loadingText = this.add.text(width * 0.5, height * 0.5, 'Loading', {
            fontFamily: 'Rubik',
            color: '#ffffff',
            fontSize: '42px',
            align: 'center',
        });
        this.loadingText.setOrigin(0.5, 0.5);
        this.load.on('progress', (value) => {
            this.loadingText.setText(`Loading ${Math.floor(value * 100)}%`);
        });
        this.load.on('complete', ()=>{
            this.loadingText.destroy(true);
            this.scene.start('MainScene');
        })
    }

    private loadAssets(): void {
        const { images, spines, atlases } = assetPaths;
        images.forEach((e) => this.load.image(e.name, e.path));
        spines.forEach((e) => this.load.spine(e.key, e.jsonURL, e.atlasURL));
        atlases.forEach((e) => this.load.atlas(e.name, e.png, e.json));
        this.load.start();
    }
}
